var map = {
	"./Manual_MFA_Laptop_only_de.pdf": 9014,
	"./Manual_MFA_Laptop_only_en.pdf": 2918,
	"./Manual_MFA_Laptop_only_es.pdf": 1197,
	"./Manual_MFA_Laptop_only_fr.pdf": 6869,
	"./Manual_MFA_Laptop_only_ms.pdf": 9141,
	"./Manual_MFA_Laptop_only_pl.pdf": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4049;